import { render } from "./NewUserView.vue?vue&type=template&id=8c7fdae8&scoped=true"
import script from "./NewUserView.vue?vue&type=script&lang=js"
export * from "./NewUserView.vue?vue&type=script&lang=js"

import "./NewUserView.vue?vue&type=style&index=0&id=8c7fdae8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c7fdae8"]])

export default __exports__